import * as React from 'react'
import { useState } from "react"
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import FormControl from '@mui/material/FormControl';
import { MenuItem } from '@mui/material';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';

import '../Controls.css';

function SmallControls(props) {

    React.useEffect(() => {
        // Code for small screen
        // Get buttons and modal
        var searchButtonS = document.getElementById("searchButtonS");
        var orderButtonS = document.getElementById("orderButtonS");
        var addButtonS = document.getElementById("addButtonS"); 
        var closeS = document.getElementById("closeControlS");
        var controlModal = document.getElementById("controlsModal")
        // Get section
        var searchS = document.getElementById("searchS");
        var orderS = document.getElementById("orderS");
        var addS = document.getElementById("addS"); 
        // Show each section
        searchButtonS.onclick = function() {
            // Hide differents sections
            orderS.style.display = 'none';
            addS.style.display = 'none'
            //Show section
            searchS.style.display = 'block'
            controlModal.style.display = 'block';
        }

        orderButtonS.onclick = function() {
            // Hide differents sections
            searchS.style.display = 'none';
            addS.style.display = 'none'
            //Show section
            orderS.style.display = 'block'
            controlModal.style.display = 'block';
        }

        addButtonS.onclick = function() {
            // Hide differents sections
            searchS.style.display = 'none';
            orderS.style.display = 'none'
            //Show section
            addS.style.display = 'block'
            controlModal.style.display = 'block';
        }

        // When the user clicks anywhere outside of the modal, close it
        window.onclick = function(event) {
            if (event.target === controlModal) {
                controlModal.style.display = 'none';
            }
        }

        // Close button
        closeS.onclick = function() {
            controlModal.style.display = 'none';
        }

        // Controls not lower than foot
        var controls = document.getElementById("smallControls")
        var controlsStyle = controls.style

        window.onscroll = function() {
           if (window.innerHeight + window.scrollY > document.body.scrollHeight - 300) {
                controls.style = 'position: static; padding-top: 40px'
           } else {
                controls.style = controlsStyle
           }
        }
    })

    const [criteria, setCrtieria] = useState('')
    const [query, setQuery] = useState('')
    const [order, setOrder] = useState('')

    return(
        <React.Fragment>
            {/* Code for small screens */}
            <div id="smallControls">
                <div id="searchButtonS" className="control controls-s"><span className="material-icons-round controls">search</span></div>
                <div id="orderButtonS" className="control controls-s"><span className="material-icons-round controls">filter_list</span></div>
                <div id="addButtonS" className="control controls-s"><span className="material-icons-round controls">add_circle</span></div>
            </div>

            <div id="controlsModal" className="control-modal">
                <div className="control-modal-content">
                    <div id="closeControlS">&times;</div>

                    <div id="searchS">
                        <div className='s-controls-label'>Buscar</div>
                        <FormControl fullWidth>
                                <div className='form-input-tag-s'>
                                    <InputLabel id="demo-simple-select-label">Criterio</InputLabel>
                                    <Select fullWidth value={criteria} onChange={(e) => setCrtieria(e.target.value)} label="Criterio">
                                        <MenuItem value={0}>Radicado</MenuItem>
                                        <MenuItem value={1}>Demandante</MenuItem>
                                        <MenuItem value={2}>Demandado</MenuItem>
                                        <MenuItem value={3}>Fecha</MenuItem>
                                        <MenuItem value={4}>Materia</MenuItem>
                                    </Select>
                                </div>
                                <div className='form-input-tag-s'>
                                    <TextField 
                                        onChange={(e) => setQuery(e.currentTarget.value)} 
                                        id="filled-basic" placeholder="Buscar ..."  variant="filled"
                                    /> 
                                </div>
                        </FormControl>
                        <Button onClick={() => props.queryCases(props.casos, criteria, query)}>Buscar</Button>
                    </div>
                    <div id="orderS">
                        <Form>
                            <div className="s-controls-label">Ordenar</div>
                            <FormControl fullWidth>
                                <div className='form-input-tag-s'>
                                    <InputLabel id="demo-simple-select-label">Criterio</InputLabel>
                                    <Select fullWidth value={criteria} onChange={(e) => setCrtieria(e.target.value)} label="Criterio">
                                        <MenuItem value={0}>Radicado</MenuItem>
                                        <MenuItem value={1}>Demandante</MenuItem>
                                        <MenuItem value={2}>Demandado</MenuItem>
                                        <MenuItem value={3}>Fecha</MenuItem>
                                        <MenuItem value={4}>Materia</MenuItem>
                                    </Select>
                                </div>
                            </FormControl>
                            <FormControl fullWidth>
                                <div className='form-input-tag-s'>
                                <InputLabel id="demo-simple-select-label">Orden</InputLabel>
                                    <Select fullWidth value={criteria} onChange={(e) => {
                                        setOrder(e.target.value);
                                        props.sortCases(props.casos, criteria, order)
                                    }} label="Orden">
                                        <MenuItem value={1}>Ascendente</MenuItem>
                                        <MenuItem value={0}>Descendente</MenuItem>
                                    </Select>
                                </div>
                            </FormControl>
                            <Button>Ordenar</Button>
                        </Form>
                    </div>
                    <div id="addS">
                        <Form>
                            <div className="s-controls-label">Agegar</div>
                            <FormControl fullWidth>
                                <div className='form-input-tag-s'>
                                    <TextField id="filled-basic" placeholder="Digita el radicado del proceso" variant="filled"
                                                onChange={(e) => {
                                                    if (e.target.value.length === 23) {
                                                        props.setNumeroCaso(e.target.value);
                                                        props.setNumeroValido(true);
                                                } else props.setNumeroValido(false);
                                                }}/>
                                </div>
                                <div className='form-input-tag right'>
                                <Button className='add-case' disabled={!props.numeroValido}
                                            onClick={() => {props.newCase(props.numeroCaso); props.setAddLoad(false)}}>Agregar </Button></div>
                            </FormControl>
                        </Form>
                    </div>
                </div>
            </div>     
        </React.Fragment>
    )
}

export { SmallControls }